<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div class="d-flex flex-wrap">
      <div class="waffle-split-date-container waffle-hover-border"
           :class="{ 'border-setup': !hasBeenInteractedWith,
           invalid: hasBeenInteractedWith && fieldError && ((month && month.length === 2 && day.length === 2 && year.length === 4) || focus.every(f => !f))}">
        <input
            style="outline: none;"
            v-bind="$attrs"
            :value="displayValues.month"
            type="tel"
            :id="`waffle-split-date-input_${question.name}__month`"
            :name="`waffle_${question.name}`"
            :disabled="question.status === 'DISABLED'||disabled"
            :aria-disabled="question.status === 'DISABLED'||disabled"
            @focusin="focus[0] = true"
            @input="
            month = $event.target.value;
            restrictChar($event, 'month');
            focusNext(month, 2, 'day');
            validateInput($event, 0);
          "
            ref="monthInput"
            class="waffle-split-date-input"
            :class="{
              adjust: month,
            }"
            @blur="focus[0] = false;  $emit('user-interaction');prependZeros('month'); validateAll()"
        />
        <span class="waffle-split-date-placeholder"> MM</span>
      </div>

      <div class="waffle-split-date-container waffle-hover-border"
           :class="{ 'border-setup': !hasBeenInteractedWith,
           invalid: hasBeenInteractedWith && fieldError && ((month && month.length === 2 && day.length === 2 && year.length === 4) || focus.every(f => !f))}">        <input
            :value="displayValues.day"
            :id="`waffle-split-date-input_${question.name}__day`"
            type="tel"
            ref="dayInput"
            :name="`waffle_${question.name}`"
            @focusin="focus[1] = true"
            :disabled="question.status === 'DISABLED'||disabled"
            :aria-disabled="question.status === 'DISABLED'||disabled"
            @input="
            day = $event.target.value;
            restrictChar($event,'day');
            focusNext(day, 2, 'year');
            validateInput($event, 1)
            "
            :class="{
              invalid: hasBeenInteractedWith && fieldError && ((month && month.length === 2 && day.length === 2 && year.length === 4) || focus.every(f => !f)),
              adjust: day,
            }"
            class="waffle-split-date-input"
            @blur="focus[1] = false;  $emit('user-interaction');prependZeros('day'); validateAll()"
        />
        <span class="waffle-split-date-placeholder"> DD </span>
      </div>

      <div class="waffle-split-date-container waffle-hover-border"
           :class="{ 'border-setup': !hasBeenInteractedWith,
           invalid: hasBeenInteractedWith && fieldError && ((month && month.length === 2 && day.length === 2 && year.length === 4) || focus.every(f => !f))}">
        <input
            style="outline: none;"
            :value="displayValues.year"
            :id="`waffle-split-date-input_${question.name}__year`"
            type="tel"
            ref="yearInput"
            :name="`waffle_${question.name}`"
            @focusin="focus[2] = true"
            :disabled="question.status === 'DISABLED'||disabled"
            :aria-disabled="question.status === 'DISABLED'||disabled"
            @blur="focus[2] = false; $emit('user-interaction');validateAll()"
            @input="
            year = $event.target.value;
            restrictChar($event, 'year');
            focusNext(year, 4, '');
            validateInput($event, 2)
          "
            :class="{
              invalid: hasBeenInteractedWith && fieldError && ((month && month.length === 2 && day.length === 2 && year.length === 4) || focus.every(f => !f)),
              adjust: year,
            }"
            class="waffle-split-date-input"
        />
        <span class="waffle-split-date-placeholder"> YYYY </span>
      </div>
    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question.value && question?.prefilled) && !displayErrorMessage" :isError="displayErrorMessage  && hasBeenInteractedWith && ((month && month.length === 2 && day.length === 2 && year.length === 4) || focus.every(f => !f)) ? displayErrorMessage:null"
          :confirmCb="() =>{ $emit('user-interaction'); $emit('confirm');}"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="displayValues.readonly"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>
<script>
import moment from "moment";
import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  name: "SplitDate",
  components: {ReadOnly},
  emits: ["update:modelValue", "field-error", 'confirm','user-interaction'],
  props: ["question", "modelValue", "hideSubText", 'skipEagerValidation','disableConfirm','forcePromptPlaceholder','hasBeenInteractedWith','disabled'],
  mounted() {
    if (this.question.value) {
      const dt = this.parseDate(this.question.value);
      if (dt) {
        this.month = dt.month;
        this.day = dt.day;
        this.year = dt.year;
      }

      if (!this.skipEagerValidation) {
        this.outOfRangeMessage = this.question.error;
        this.validateInput({target: {value: this.month}}, 0);
        this.validateInput({target: {value: this.day}}, 1);
        this.validateInput({target: {value: this.year}}, 2);
      }
    } else {
      if (!this.skipEagerValidation) {
        this.validateInput({target: {value: null}}, null);
      }
    }

  },
  watch:{
    question:{
      handler:function(newQuestion){
        if (newQuestion.value) {
          if(newQuestion.value !== `${this.year}${this.month.length < 2 ? '0' : ''}${this.month}${this.day.length < 2 ? '0' : ''}${this.day}`){
            this.$emit(
                "update:modelValue",
                newQuestion.value
            );
          }

          const dt = this.parseDate(newQuestion.value);
          if (dt) {
            this.month = dt.month;
            this.day = dt.day;
            this.year = dt.year;
          }

          if(newQuestion.error){
            this.$nextTick(() => {
              this.outOfRangeMessage = newQuestion.error;
              this.$emit("field-error", true);
            })
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      month: "",
      day: "",
      year: "",
      isInvalid: [null, null, null],
      outOfRangeMessage: null,
      labels: ["Month", "Day", "Year"],
      focus:[false, false, false]
    };
  },
  computed: {
    isInputFocused(){
      return this.focus.some(el => el)
    },
    isPII(){
      return this.question.criteria.find(el => typeof el === 'object')?.pii_masking
    },
    displayValues(){
      const readonlyString = this.month ? (`${this.month.length < 2 ? '0' : ''}${this.month}/${this.day.length < 2 ? '0' : ''}${this.day}/${this.year}`):'-'
        if(this.isInputFocused || (!this.isInputFocused && !this.isPII)){
          return {
            day: this.day,
            month: this.month,
            year: this.year,
            readonly: readonlyString
          }
        }else{
          return {
            day: String(this.day)?.replace(/[a-zA-Z0-9]/g,'*'),
            month: String(this.month)?.replace(/[a-zA-Z0-9]/g,'*'),
            year: String(this.year)?.substring(0, String(this.year).length-2)?.replace(/[a-zA-Z0-9]/g,'*') + String(this.year)?.substring(String(this.year).length-2),
            readonly: readonlyString?.substring(0, readonlyString.length -2)+readonlyString?.substring(readonlyString.length -2)
          }
        }
      },
    fieldError() {
      return this.isInvalid?.some((e) => e) || this.outOfRangeMessage;
    },
    displayErrorMessage() {
      const invalid =
          this.isInvalid.filter((el) => el).length >= 3
              ? "Date is required"
              : this.isInvalid.filter((el) => el)[0];
      return invalid ?? "" + (this.outOfRangeMessage || "");
    },
  },
  methods: {
    validateAll(){
      this.$nextTick(() => {
        if(this.focus.every(el => !el)){
          this.validateInput({target: {value: this.month}}, 0);
          this.validateInput({target: {value: this.day}}, 1);
          this.validateInput({target: {value: this.year}}, 2);
        }
      })
    },
    parseDate(dateString) {
      const formats = ["YYYY-MM-DD", "MM/DD/YYYY", "YYYYMMDD"];
      const parsedDate = moment(dateString, formats, true); // The true parameter enables strict parsing

      if (parsedDate.isValid()) {
        const day = `${parsedDate.date() < 10 ? '0' : ''}${parsedDate.date()}`;
        const month = `${parsedDate.month() + 1 < 10 ? '0' : ''}${parsedDate.month() + 1}`; // Month starts from 0
        const year = parsedDate.year();

        return {
          day: day,
          month: month,
          year: year,
        };
      } else {
        return null; // Invalid date format
      }
    },
    prependZeros(origin) {
      if (this.day.length < 2 && this.day.length !== 0 && origin === 'day') {
        this.day = '0' + this.day;
      }
      if (this.month.length < 2 && this.month.length !== 0 && origin === 'month') {
        this.month = '0' + this.month;
      }
    },
    restrictChar(e, part) {
      this[part] = this[part].replace(/[^0-9]/g, "");

      const charLenghtLimits = {month: 2, day: 2, year: 4}
      if (this[part].length > charLenghtLimits[part]) {
        if (this[part][0] === '0') {
          return this[part] = e.target.value.substring(1)
        }
        this[part] = this[part].substring(0, charLenghtLimits[part])
      }
    },
    isValidMonth(m) {
      const month = parseInt(m);
      return month >= 1 && month <= 12;
    },

    isValidDay(day) {
      const d = parseInt(day);
      return d >= 1 && d <= 31;
    },
    validateInput(e, part) {
      const val = e.target.value;
      const partLabel = part ? this.labels[part] : "Date";
      const frontendCriteria = this.question.criteria.find(
          (el) => typeof el === "object"
      );

      if (this.question?.required) {
        this.isInvalid[0] = this.month
            ? this.isValidMonth(this.month)
                ? null
                : "Invalid month"
            : "Month is required";
        this.isInvalid[1] = this.day
            ? this.isValidDay(this.day, this.month)
                ? null
                : "Invalid day"
            : "Day is required";
        this.isInvalid[2] = this.year.length < 4 ? (this.year.length > 0 ? "Must provide a 4 digit year." : "Year is required") : '';

        this.$emit(
            "field-error",
            this.isInvalid.filter((val) => val).length > 0
        );
      }

      if (frontendCriteria && frontendCriteria.regex) {
        const regex = new RegExp(frontendCriteria.regex[part]);
        if (!regex.test(val)) {
          this.isInvalid[part] = `Invalid ${partLabel}`;
          this.$emit("field-error", true);
          return e.preventDefault();
        } else {
          this.isInvalid[part] = null;
        }
      }

      const allFieldsComplete = this.month && this.day && this.year;

      if (frontendCriteria && frontendCriteria.range && allFieldsComplete) {
        const minDate = moment(frontendCriteria.range[0])
        const maxDate = moment(frontendCriteria.range[1])
        const inputDate = moment(
            `${this.month}/${this.day}/${this.year}`,
            "MM/DD/YYYY"
        );

        if (!inputDate.isBetween(minDate, maxDate, undefined, "[]")) {
          this.$emit("field-error", true);
          return (this.outOfRangeMessage = `Date must be between ${minDate.format(
              "L"
          )} and ${maxDate.format("L")}`);
        } else {
          this.outOfRangeMessage = null;
        }
      }

      if (allFieldsComplete && this.isInvalid.every((e) => !e)) {
        this.$emit("field-error", false);
        return this.$emit(
            "update:modelValue",
            `${this.year}${this.month.length < 2 ? '0' : ''}${this.month}${this.day.length < 2 ? '0' : ''}${this.day}`
        );
      }
    },
    focusNext(val, maxlength, next) {
      if (val.length === maxlength) {
        if (next !== "") {
          this.$refs[`${next}Input`]?.focus();
        } else {
        this.$refs.yearInput?.blur();
        }
      }
    }
  },
};
//TODO:CLEAN UP AND REFINE CSS
</script>
